







import {Component, Prop, Mixins} from 'vue-property-decorator'
import {StatusTagView, StatusTagType, StatusTagSize} from './models'
import inputThemeMixin from '@/mixins/inputThemeMixin'

@Component
export default class StatusTag extends Mixins(inputThemeMixin) {

  @Prop({ default: 'none' }) readonly type?: StatusTagType
  @Prop({ default: '' }) readonly view?: StatusTagView
  @Prop({ default: '' }) readonly size?: StatusTagSize

  get modifiers(): string[] {
    let res: string[] = [];
    let props = this.$props;
    Object.keys(props)?.forEach((key: string) => {
      let val = props[key];
      if (val) {
        res.push(key + '-' + val);
      }
    });
    return res;
  }

}
